import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { of, Subscription } from 'rxjs';
import { catchError, tap, take } from 'rxjs/operators';
import { ScreeningDraft } from 'src/app/models/screeningDraft';
import { ScreeningLight, EndUserCertification } from 'src/app/models/screeningInvite';
import { AuthService } from 'src/app/services/auth.service';
import { ScreeningDraftService } from '../services/screening-draft.service';
import { ScreeningService } from '../services/screening.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-screenings-draft-list',
  templateUrl: './screenings-draft-list.component.html',
  styleUrls: ['./screenings-draft-list.component.less']
})
export class ScreeningsDraftListComponent implements OnInit {
  loading: boolean = false;
  

  public get screeningList() : Array<ScreeningDraft> {
    if(!this.drafts.draftsList) return [];
    return this.drafts.draftsList.filter(drft=>{return !drft.archived;});
  }
  
  constructor(private drafts: ScreeningDraftService, private toast: ToastrService, public auth: AuthService,private location : Router) { }
  
  ngOnInit() {
    this.loading = true;
    this.drafts.FetchDrafts()
      .pipe(
        take(1),
        tap(_ => { this.drafts.draftsList = _ })).subscribe(() => {}, err => {
          this.toast.error('Error fetching screening drafts!')
        },
        () => {
          this.loading = false;
          this.drafts.draftsList.forEach(drft =>{
            drft = Object.assign(new ScreeningDraft(),drft);
          })
        });
  }
    

  loadDraft(draft: ScreeningDraft, docsOverride : boolean = false) {
    this.drafts.directOrderDemographics = draft;
    // console.log('Draft Loaded',this.drafts.directOrderDemographics)
    this.drafts.FetchECForDraft().pipe(take(1),tap((_: EndUserCertification) =>{ 
      this.drafts.directOrderDemographics.certification = Object.assign(new EndUserCertification(),_);
      // console.log(this.drafts.directOrderDemographics);
    })).subscribe(null,(err: any)=>{
      this.toast.error('Error loading your screening draft');
    },()=>{
      if(docsOverride){
        this.drafts.directOrderDemographics.phaseOverride = 2;
      }
      this.location.navigateByUrl('/screenings/new');
    })
  }

  archive(draft:ScreeningDraft){
    draft.archived = true;
    this.drafts.SaveDraft(draft).pipe(take(1),tap()).subscribe(()=>{
      this.toast.success('','Draft Archived!');
    },()=>{
      this.toast.error('There was an error archiving your draft, If the issue persists please contact support.','Archive Error');
    })
  }


}
